<template>
  <Screen>
    <AppBar :title="title" />
    <Breadcrumbs
      :links="[
        {
          to: $route('admin.blissdom.guidedmeditation.index'),
          title: 'Meditation tracks',
        },
      ]"
      :title="title"
    />
    <div class="row">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <form
              action=""
              method="post"
              @submit.prevent="submit"
              v-if="formSet"
            >
              <TextBox
                name="title"
                v-model="form.title"
                :disabled="form.processing"
                :error="form.errors.title"
              />
              <TextBox
                name="sort_order"
                v-model="form.sort_order"
                :disabled="form.processing"
                :error="form.errors.sort_order"
              />

              <FileInput
                name="thumbnail"
                label="Thumbnail (Optional)"
                v-model="form.thumbnail"
                :fileUrl="form.thumbnail_url"
                :disabled="form.processing"
                :error="form.errors.thumbnail"
                helperText="Ideal size is 600x600 pixels or aspect ratio of 1:1. Upload svg file for better quality"
              />
              <div class="form-group">
                <label for="audio">Audio file</label>
                <div class="custom-file">
                  <input
                    name="audio"
                    type="file"
                    class="custom-file-input"
                    id="audio"
                    accept="audio/*"
                    :disabled="form.processing"
                    :class="{ 'is-invalid': form.errors.audio }"
                    @change="audioOnChange"
                  />
                  <label
                    class="custom-file-label"
                    for="audio"
                    v-text="fileName"
                  ></label>
                </div>
                <small class="text-dim font-weight-bold" v-if="editMode"
                  >Leave blank to keep existing file</small
                >
                <transition name="form-error">
                  <div
                    class="error"
                    v-if="form.errors.audio"
                    v-text="form.errors.audio"
                  ></div>
                </transition>
              </div>
              <div class="row">
                <div class="col-auto">
                  <StatusRadio
                    v-model="form.isactive"
                    :disabled="form.processing"
                    :error="form.errors.isactive"
                  />
                </div>
                <div class="col-auto">
                  <StatusRadio
                    label="Premium content"
                    :radioLabel="['Premium', 'Free']"
                    name="is_premium"
                    v-model="form.is_premium"
                    :disabled="form.processing"
                    :error="form.errors.is_premium"
                  />
                </div>
              </div>

              <div class="mt-4 text-center">
                <button
                  class="btn btn-primary w-25"
                  type="submit"
                  :disabled="form.processing"
                  @click.prevent="submit"
                >
                  <div
                    class="spinner-border spinner-border-sm"
                    role="status"
                    v-if="form.processing"
                  ></div>
                  <span v-else>Save</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Screen>
</template>
<script>
import FileInput from "@/components/form/fileInput.vue";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    formData: {
      type: [Object, Array],
      default: () => {},
    },
    submitUrl: {
      type: String,
      default: "",
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FileInput,
  },
  data() {
    return {
      form: {},
      formSet: false,
      fileName: "Choose file",
    };
  },
  mounted() {
    setTimeout(() => {
      this.form = this.$inertia.form(this.formData);
      this.fileName = this.form.audio || "Choose file";
      this.form.audio = null;
      this.form.thumbnail = null;
      setTimeout(() => {
        this.formSet = true;
      });
    });
  },
  methods: {
    submit() {
      this.form.post(this.submitUrl, {
        onSuccess: () => this.form.reset(),
      });
    },
    audioOnChange(event) {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);

      reader.onload = () => {
        this.fileName = event.target.files[0].name;
        this.form.audio = event.target.files[0];
      };
    },
  },
  computed: {},
};
</script>
